import React, { useState } from 'react';
import { Button, Modal } from 'antd-mobile';

const SubmitConfirmation = (props) => {
  const { isModalVisible, setIsModalVisible, okFunction, typeName } = props;
  const handleOk = () => {
    setIsModalVisible(false);
    okFunction();
  };

  return (
    <>
      <Modal
        title="預約資料已送出"
        showCloseButton={true}
        visible={isModalVisible}
        onOk={handleOk}
        onClose={handleOk}
        content={
          <div className="text-align-center">
            <img
              className="mt-4"
              src="/images/illustration/individual-success.svg"
            />
            <div>
              <p className="text-body font-normal px-2">
                您的{typeName}預約表單已
                <span className="red">提交成功</span>
                ！我們將為您安排最適合的{typeName}時間，請耐心等候～
              </p>
            </div>
            <Button
              style={{ marginTop: '12px' }}
              block
              onClick={handleOk}
              className="secondary-button">
              好的
            </Button>
          </div>
        }></Modal>
    </>
  );
};

export default SubmitConfirmation;
